import axios from 'axios';
import { ADMIN_API } from '../utils/constants';

const getToken = () => localStorage.getItem('token');

const authHeader = () => ({
    headers: {
        Authorization: `Bearer ${getToken()}`
    }
});

const extractToken = (payload) => {
    if (typeof payload === 'string') {
        return payload;
    }

    if (payload && typeof payload === 'object') {
        return payload.token
            || payload.jwtToken
            || payload.accessToken
            || payload.data?.token
            || payload.data?.jwtToken
            || '';
    }

    return '';
};

// Login admin
export const loginAdmin = async (loginData) => {
    const loginRoutes = [
        `${ADMIN_API}/login`,
        `${ADMIN_API}/signin`,
        `${ADMIN_API}/authenticate`,
        `${ADMIN_API.replace(/s$/, '')}/login`,
        `${ADMIN_API.replace(/s$/, '')}/signin`,
        `${ADMIN_API.replace(/s$/, '')}/authenticate`
    ];

    let lastError;

    for (const url of loginRoutes) {
        try {
            const response = await axios.post(url, loginData);
            return extractToken(response.data);
        } catch (error) {
            lastError = error;
            if (error.response?.status !== 404) {
                throw error;
            }
        }
    }

    throw lastError;
};

// Register admin
export const registerAdmin = async (adminData) => {
    const response = await axios.post(
        `${ADMIN_API}/register`, adminData);
    return response.data;
};

// Get all poojaris
export const getAllPoojaris = async () => {
    const response = await axios.get(
        `${ADMIN_API}/poojaris/all`, authHeader());
    return response.data;
};

// Get pending poojaris
export const getPendingPoojaris = async () => {
    const response = await axios.get(
        `${ADMIN_API}/poojaris/pending`, authHeader());
    return response.data;
};

// Approve poojari
export const approvePoojari = async (id) => {
    const response = await axios.put(
        `${ADMIN_API}/poojaris/approve/${id}`, {}, authHeader());
    return response.data;
};

// Reject poojari
export const rejectPoojari = async (id) => {
    const response = await axios.put(
        `${ADMIN_API}/poojaris/reject/${id}`, {}, authHeader());
    return response.data;
};

// Suspend poojari
export const suspendPoojari = async (id) => {
    const response = await axios.put(
        `${ADMIN_API}/poojaris/suspend/${id}`, {}, authHeader());
    return response.data;
};

// Get all users
export const getAllUsers = async () => {
    const response = await axios.get(
        `${ADMIN_API}/users/all`, authHeader());
    return response.data;
};

// Toggle user status
export const toggleUserStatus = async (id) => {
    const response = await axios.put(
        `${ADMIN_API}/users/toggle-status/${id}`, {}, authHeader());
    return response.data;
};